import { useMemo } from "react";
import { useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants";

import { type AllowedLanding, type ClientAppWithLandings } from "./types";

export const useClientAppAllowedLandings = (selectedClientAppId?: string) => {
  const { data: clientApps, isLoading } = useGetList<ClientAppWithLandings>(
    MODULE_NAMES.CLIENT_APPS,
  );

  const allowedLandings = useMemo<AllowedLanding[]>(
    () =>
      clientApps?.find((app) => app.id === selectedClientAppId)
        ?.allowedLandings ?? [],
    [clientApps, selectedClientAppId],
  );

  return { allowedLandings, isLoading };
};
